import { createSharedComposable, useLocalStorage } from "@vueuse/core";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

function useCommandKControlsFn() {
  const isOpen = ref(false);

  return {
    isOpen,
  };
}

export const useCommandKControls = createSharedComposable(useCommandKControlsFn);

type SearchMode = "name" | "deep";

export const useSearchStore = defineStore("search", () => {
  const mode = useLocalStorage<SearchMode>("search-mode", "deep");

  const nameOnly = computed<boolean>({
    get: () => mode.value === "name",
    set: flag => {
      mode.value = flag ? "name" : "deep";
    },
  });

  return { nameOnly };
});
